import { useState, useCallback } from 'react';
import { issuesApi } from '../../api/issuesApi';
import { Issue } from '../../types/issues';

export function useCreateIssue() {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const submit = useCallback(async (
        data: Omit<Issue, 'key' | 'createdBy' | 'createdAt'>
    ): Promise<string> => {
        setLoading(true);
        setError(null);
        try {
            const key = await issuesApi.create(data);
            return key;
        } catch (err: any) {
            const message = err.message || 'Kunde inte skapa felanmälan';
            setError(message);
            throw new Error(message);
        } finally {
            setLoading(false);
        }
    }, []);

    const clearError = useCallback(() => setError(null), []);

    return { submit, loading, error, clearError };
}
